import {dataFetcher} from "../../services/dataGuetter/dataFetcher";


export async function getAllTypesContrat():Promise<TypeContrat[]>{
    const res:any = await dataFetcher(`type_contrats`, {method:'get'})
    return res["hydra:member"];
}